// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper--hgu6E","inner":"inner--eu8xr","tagline":"tagline--Gkvcn","headline":"headline--MEuNh","fadeSlideUp":"fadeSlideUp--lHRi4"};